// RecTattooPiercingShop.jsx - Professional Tattoo & Piercing Guide
import React from "react";
import { Link } from "react-router-dom";
import { useI18n } from "../contexts/I18n";
import "./recommended.css";

const recommendedItems = [
  { title: "hairTrendsStylingGuide", image: "images/hair.jpg", slug: "hair-&-nail-salon" },
  { title: "mensGroomingMustacheStyles", image: "images/barbershop.jpg", slug: "barbershop" },
  { title: "tattooIdeasArtistGuide", image: "images/tattoo.jpg", slug: "tattoo-&-piercing-shops" },
  { title: "hairRemovalSkincare", image: "images/hair1.jpg", slug: "hair-removal" },
  { title: "browLashEnhancement", image: "images/brows.jpg", slug: "makeup-&-brows-&-lashes" },
  { title: "spaWellnessTreatments", image: "images/massage.jpg", slug: "massage-&-aesthetic-medicine" },
];

export default function RecTattooPiercingShop() {
  const { t, lang } = useI18n();
  
  const handleTocClick = (e, targetId) => {
    e.preventDefault();
    const element = document.getElementById(targetId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };
  
  return (
    <div className="rec-page" dir={lang === 'ar' ? 'rtl' : 'ltr'}>
      <details className="rec-mobile-panel" role="navigation" aria-label="Recommended quick links">
        <summary>
          {t('recommendedServices')}
                    <span className="rec-plus" aria-hidden="true">+</span>

          <span className="rec-plus" aria-hidden="true"></span>
        </summary>
        <ul className="rec-quick-list">
          {recommendedItems.map((it) => (
            <li key={it.slug}>
              <Link to={`/rec/${it.slug}`}>{t(it.title)}</Link>
            </li>
          ))}
        </ul>
      </details>

      <aside className="rec-left" aria-label="Recommended Services">
        <h2 className="rec-left__title">{t('recommendedServices')}</h2>
        <ul className="rec-left__list">
          {recommendedItems.map((it) => (
            <li key={it.slug} className="rec-left__item">
              <Link to={`/rec/${it.slug}`} className="rec-left__link">
                <img className="rec-left__thumb" src={`/${it.image}`} alt="" />
                <span className="rec-left__label">{t(it.title)}</span>
              </Link>
            </li>
          ))}
        </ul>
      </aside>

      <article className="rec-article">
        <header className="rec-hero">
          <h1>{t('completeTattooPiercingGuide')}</h1>
          <p className="rec-meta">{t('professionalBodyArtGuide')}</p>
          <p className="rec-dek">
            {t('exploreWorldBodyArt')}
          </p>
          <div className="rec-cta-row">
            <Link className="btn primary" to="/service/tattoo-&-piercing-shops">{t('bookTattooConsultation')}</Link>
            <Link className="btn outline" to="/service/tattoo-&-piercing-shops">{t('viewAllServices')}</Link>
          </div>
        </header>

        <nav className="rec-toc" aria-label="Table of Contents">
            <h2>{t('tableOfContents')}</h2>
          <div className="rec-toc-summary">
            <p><strong>5 {t('sections')}</strong> • <strong>51 {t('minTotalRead')}</strong></p>
          </div>
          <ul className="rec-toc-list">
            <li className="rec-toc-item">
              <a href="#tattoo-designs" className="rec-toc-link" onClick={(e) => handleTocClick(e, 'tattoo-designs')}>
                <div className="rec-toc-content">
                  <h3 className="rec-toc-title">{t('professionalTattooDesign')}</h3>
                  <p className="rec-toc-description">{t('exploreTattooArtStyles')}</p>
                  <div className="rec-toc-meta">
                    <span className="rec-toc-time">15 {t('minRead')}</span>
                    <span className="rec-toc-difficulty rec-toc-difficulty--intermediate">{t('intermediate')}</span>
                  </div>
                  </div>
                </a>
              </li>
            <li className="rec-toc-item">
              <a href="#artist-selection" className="rec-toc-link" onClick={(e) => handleTocClick(e, 'artist-selection')}>
                <div className="rec-toc-content">
                  <h3 className="rec-toc-title">{t('expertTattooArtistSelection')}</h3>
                  <p className="rec-toc-description">{t('learnFindPerfectArtist')}</p>
                  <div className="rec-toc-meta">
                    <span className="rec-toc-time">10 {t('minRead')}</span>
                    <span className="rec-toc-difficulty rec-toc-difficulty--beginner">{t('beginner')}</span>
                  </div>
                  </div>
                </a>
              </li>
            <li className="rec-toc-item">
              <a href="#piercing-types" className="rec-toc-link" onClick={(e) => handleTocClick(e, 'piercing-types')}>
                <div className="rec-toc-content">
                  <h3 className="rec-toc-title">{t('completePiercingGuide')}</h3>
                  <p className="rec-toc-description">{t('discoverDifferentPiercing')}</p>
                  <div className="rec-toc-meta">
                    <span className="rec-toc-time">12 {t('minRead')}</span>
                    <span className="rec-toc-difficulty rec-toc-difficulty--beginner">{t('beginner')}</span>
                  </div>
                  </div>
                </a>
              </li>
            <li className="rec-toc-item">
              <a href="#aftercare" className="rec-toc-link" onClick={(e) => handleTocClick(e, 'aftercare')}>
                <div className="rec-toc-content">
                  <h3 className="rec-toc-title">{t('professionalAftercare')}</h3>
                  <p className="rec-toc-description">{t('recTattooMasterAftercareRoutine')}</p>
                  <div className="rec-toc-meta">
                    <span className="rec-toc-time">8 {t('minRead')}</span>
                    <span className="rec-toc-difficulty rec-toc-difficulty--beginner">{t('beginner')}</span>
                  </div>
                  </div>
                </a>
              </li>
            <li className="rec-toc-item">
              <a href="#safety-tips" className="rec-toc-link" onClick={(e) => handleTocClick(e, 'safety-tips')}>
                <div className="rec-toc-content">
                  <h3 className="rec-toc-title">{t('safetyStandardsHygiene')}</h3>
                  <p className="rec-toc-description">{t('understandEssentialSafety')}</p>
                  <div className="rec-toc-meta">
                    <span className="rec-toc-time">6 {t('minRead')}</span>
                    <span className="rec-toc-difficulty rec-toc-difficulty--beginner">{t('beginner')}</span>
                  </div>
                  </div>
                </a>
              </li>
          </ul>
        </nav>

        <section id="tattoo-designs" className="rec-section">
          <div className="rec-section-header">
            <div className="rec-section-info">
              <h3>{t('professionalTattooDesign')}</h3>
              <div className="rec-section-details">
                <span className="rec-section-time">15 {t('minRead')}</span>
                <span className="rec-section-difficulty rec-section-difficulty--intermediate">{t('intermediate')}</span>
              </div>
            </div>
          </div>
          <div className="rec-section-intro">
            <p>{t('recTattooDesignIntro')}</p>
          </div>
          <div className="rec-quick-tips">
            <h4>{t('quickTips')}</h4>
            <ul className="rec-tips-list">
              <li className="rec-tip-item"><span className="rec-tip-text">{t('recTattooDesignQuickTip1')}</span><span className="rec-tip-icon">💡</span></li>
              <li className="rec-tip-item"><span className="rec-tip-text">{t('recTattooDesignQuickTip2')}</span><span className="rec-tip-icon">💡</span></li>
              <li className="rec-tip-item"><span className="rec-tip-text">{t('recTattooDesignQuickTip3')}</span><span className="rec-tip-icon">💡</span></li>
            </ul>
          </div>
          <div className="rec-section-body">
          <div className="rec-section-content">
            <div>
              <p>{t('recTattooDesignContent1')}</p>
              
              <h4>{t('recTattooDesignContent2')}</h4>
              
              <h5>{t('recTattooDesignContent3')}</h5>
              <p>
                <strong>{t('recTattooDesignContent4')}</strong> {t('recTattooDesignContent5')}
              </p>
              <p>
                <strong>{t('recTattooDesignContent6')}</strong> {t('recTattooDesignContent7')}
              </p>
              <p>
                <strong>{t('recTattooDesignContent8')}</strong> {t('recTattooDesignContent9')}
              </p>
              
              <h5>{t('recTattooDesignContent10')}</h5>
              <p>
                <strong>{t('recTattooDesignContent4')}</strong> {t('recTattooDesignContent11')}
              </p>
              <p>
                <strong>{t('recTattooDesignContent6')}</strong> {t('recTattooDesignContent12')}
              </p>
              <p>
                <strong>{t('recTattooDesignContent13')}</strong> {t('recTattooDesignContent14')}
              </p>
              
              <h5>{t('recTattooDesignContent15')}</h5>
              <p>
                <strong>{t('recTattooDesignContent4')}</strong> {t('recTattooDesignContent16')}
              </p>
              <p>
                <strong>{t('recTattooDesignContent6')}</strong> {t('recTattooDesignContent17')}
              </p>
              <p>
                <strong>{t('recTattooDesignContent18')}</strong> {t('recTattooDesignContent19')}
              </p>
              
              <h5>{t('recTattooDesignContent20')}</h5>
              <p>
                <strong>{t('recTattooDesignContent4')}</strong> {t('recTattooDesignContent21')}
              </p>
              <p>
                <strong>{t('recTattooDesignContent6')}</strong> {t('recTattooDesignContent22')}
              </p>
              <p>
                <strong>{t('recTattooDesignContent23')}</strong> {t('recTattooDesignContent24')}
              </p>
              
              <h5>{t('recTattooDesignContent25')}</h5>
              <p>
                <strong>{t('recTattooDesignContent4')}</strong> {t('recTattooDesignContent26')}
              </p>
              <p>
                <strong>{t('recTattooDesignContent6')}</strong> {t('recTattooDesignContent27')}
              </p>
              <p>
                <strong>{t('recTattooDesignContent28')}</strong> {t('recTattooDesignContent29')}
              </p>
              
              <h4>{t('recTattooDesignContent30')}</h4>
              
              <h5>{t('recTattooDesignContent31')}</h5>
              <ul>
                <li><strong>{t('recTattooDesignContent32')}</strong> {t('recTattooDesignContent33')}</li>
                <li><strong>{t('recTattooDesignContent34')}</strong> {t('recTattooDesignContent35')}</li>
                <li><strong>{t('recTattooDesignContent36')}</strong> {t('recTattooDesignContent37')}</li>
                <li><strong>{t('recTattooDesignContent38')}</strong> {t('recTattooDesignContent39')}</li>
              </ul>
              
              <h5>{t('recTattooDesignContent40')}</h5>
              <ul>
                <li><strong>{t('recTattooDesignContent41')}</strong> {t('recTattooDesignContent42')}</li>
                <li><strong>{t('recTattooDesignContent43')}</strong> {t('recTattooDesignContent44')}</li>
                <li><strong>{t('recTattooDesignContent45')}</strong> {t('recTattooDesignContent46')}</li>
                <li><strong>{t('recTattooDesignContent47')}</strong> {t('recTattooDesignContent48')}</li>
              </ul>
            </div>
            </div>
          </div>
        </section>

        <section id="artist-selection" className="rec-section">
          <div className="rec-section-header">
            <div className="rec-section-info">
              <h3>{t('expertTattooArtistSelection')}</h3>
              <div className="rec-section-details">
                <span className="rec-section-time">10 {t('minRead')}</span>
                <span className="rec-section-difficulty rec-section-difficulty--beginner">{t('beginner')}</span>
              </div>
            </div>
          </div>
          <div className="rec-section-intro">
            <p>{t('recArtistSelectionIntro')}</p>
          </div>
          <div className="rec-quick-tips">
            <h4>{t('quickTips')}</h4>
            <ul className="rec-tips-list">
              <li className="rec-tip-item"><span className="rec-tip-text">{t('recArtistSelectionQuickTip1')}</span><span className="rec-tip-icon">💡</span></li>
              <li className="rec-tip-item"><span className="rec-tip-text">{t('recArtistSelectionQuickTip2')}</span><span className="rec-tip-icon">💡</span></li>
              <li className="rec-tip-item"><span className="rec-tip-text">{t('recArtistSelectionQuickTip3')}</span><span className="rec-tip-icon">💡</span></li>
            </ul>
          </div>
          <div className="rec-section-body">
          <div className="rec-section-content">
            <div>
              <p>{t('recArtistSelectionContent1')}</p>
              
              <h4>{t('recArtistSelectionContent2')}</h4>
              
              <h5>{t('recArtistSelectionContent3')}</h5>
              <ul>
                <li><strong>{t('recArtistSelectionContent4')}</strong> {t('recArtistSelectionContent5')}</li>
                <li><strong>{t('recArtistSelectionContent6')}</strong> {t('recArtistSelectionContent7')}</li>
                <li><strong>{t('recArtistSelectionContent8')}</strong> {t('recArtistSelectionContent9')}</li>
                <li><strong>{t('recArtistSelectionContent10')}</strong> {t('recArtistSelectionContent11')}</li>
              </ul>
              
              <h5>{t('recArtistSelectionContent12')}</h5>
              <ul>
                <li><strong>{t('recArtistSelectionContent13')}</strong> {t('recArtistSelectionContent14')}</li>
                <li><strong>{t('recArtistSelectionContent15')}</strong> {t('recArtistSelectionContent16')}</li>
                <li><strong>{t('recArtistSelectionContent17')}</strong> {t('recArtistSelectionContent18')}</li>
                <li><strong>{t('recArtistSelectionContent19')}</strong> {t('recArtistSelectionContent20')}</li>
              </ul>
              
              <h5>{t('recArtistSelectionContent21')}</h5>
              <ul>
                <li><strong>{t('recArtistSelectionContent22')}</strong> {t('recArtistSelectionContent23')}</li>
                <li><strong>{t('recArtistSelectionContent24')}</strong> {t('recArtistSelectionContent25')}</li>
                <li><strong>{t('recArtistSelectionContent26')}</strong> {t('recArtistSelectionContent27')}</li>
                <li><strong>{t('recArtistSelectionContent28')}</strong> {t('recArtistSelectionContent29')}</li>
              </ul>
              
              <h4>{t('recArtistSelectionContent30')}</h4>
              
              <h5>{t('recArtistSelectionContent31')}</h5>
              <ul>
                <li><strong>{t('recArtistSelectionContent32')}</strong> {t('recArtistSelectionContent33')}</li>
                <li><strong>{t('recArtistSelectionContent34')}</strong> {t('recArtistSelectionContent35')}</li>
                <li><strong>{t('recArtistSelectionContent36')}</strong> {t('recArtistSelectionContent37')}</li>
                <li><strong>{t('recArtistSelectionContent38')}</strong> {t('recArtistSelectionContent39')}</li>
              </ul>
              
              <h5>{t('recArtistSelectionContent40')}</h5>
              <ul>
                <li><strong>{t('recArtistSelectionContent41')}</strong> {t('recArtistSelectionContent42')}</li>
                <li><strong>{t('recArtistSelectionContent43')}</strong> {t('recArtistSelectionContent44')}</li>
                <li><strong>{t('recArtistSelectionContent45')}</strong> {t('recArtistSelectionContent46')}</li>
                <li><strong>{t('recArtistSelectionContent47')}</strong> {t('recArtistSelectionContent48')}</li>
              </ul>
              
              <h4>{t('recArtistSelectionContent49')}</h4>
              
              <h5>{t('recArtistSelectionContent50')}</h5>
              <ul>
                <li><strong>{t('recArtistSelectionContent51')}</strong> {t('recArtistSelectionContent52')}</li>
                <li><strong>{t('recArtistSelectionContent53')}</strong> {t('recArtistSelectionContent54')}</li>
                <li><strong>{t('recArtistSelectionContent55')}</strong> {t('recArtistSelectionContent56')}</li>
                <li><strong>{t('recArtistSelectionContent57')}</strong> {t('recArtistSelectionContent58')}</li>
              </ul>
              
              <h5>{t('recArtistSelectionContent59')}</h5>
              <ul>
                <li><strong>{t('recArtistSelectionContent60')}</strong> {t('recArtistSelectionContent61')}</li>
                <li><strong>{t('recArtistSelectionContent62')}</strong> {t('recArtistSelectionContent63')}</li>
                <li><strong>{t('recArtistSelectionContent64')}</strong> {t('recArtistSelectionContent65')}</li>
                <li><strong>{t('recArtistSelectionContent66')}</strong> {t('recArtistSelectionContent67')}</li>
              </ul>
            </div>
            </div>
          </div>
        </section>

        <section id="piercing-types" className="rec-section">
          <div className="rec-section-header">
            <div className="rec-section-info">
              <h3>{t('completePiercingGuide')}</h3>
              <div className="rec-section-details">
                <span className="rec-section-time">12 {t('minRead')}</span>
                <span className="rec-section-difficulty rec-section-difficulty--beginner">{t('beginner')}</span>
              </div>
            </div>
          </div>
          <div className="rec-section-intro">
            <p>{t('recPiercingIntro')}</p>
          </div>
          <div className="rec-quick-tips">
            <h4>{t('quickTips')}</h4>
            <ul className="rec-tips-list">
              <li className="rec-tip-item"><span className="rec-tip-text">{t('recPiercingQuickTip1')}</span><span className="rec-tip-icon">💡</span></li>
              <li className="rec-tip-item"><span className="rec-tip-text">{t('recPiercingQuickTip2')}</span><span className="rec-tip-icon">💡</span></li>
              <li className="rec-tip-item"><span className="rec-tip-text">{t('recPiercingQuickTip3')}</span><span className="rec-tip-icon">💡</span></li>
            </ul>
          </div>
          <div className="rec-section-body">
          <div className="rec-section-content">
            <div>
              <p>{t('recPiercingContent1')}</p>
              
              <h4>{t('recPiercingContent2')}</h4>
              
              <h5>{t('recPiercingContent3')}</h5>
              <p>
                <strong>{t('recPiercingContent4')}</strong> {t('recPiercingContent5')}
              </p>
              <p>
                <strong>{t('recPiercingContent6')}</strong> {t('recPiercingContent7')}
              </p>
              <p>
                <strong>{t('recPiercingContent8')}</strong> {t('recPiercingContent9')}
              </p>
              <p>
                <strong>{t('recPiercingContent10')}</strong> {t('recPiercingContent11')}
              </p>
              
              <h5>{t('recPiercingContent12')}</h5>
              <p>
                <strong>{t('recPiercingContent4')}</strong> {t('recPiercingContent13')}
              </p>
              <p>
                <strong>{t('recPiercingContent6')}</strong> {t('recPiercingContent14')}
              </p>
              <p>
                <strong>{t('recPiercingContent8')}</strong> {t('recPiercingContent15')}
              </p>
              <p>
                <strong>{t('recPiercingContent16')}</strong> {t('recPiercingContent17')}
              </p>
              
              <h4>{t('recPiercingContent18')}</h4>
              
              <h5>{t('recPiercingContent19')}</h5>
              <p>
                <strong>{t('recPiercingContent4')}</strong> {t('recPiercingContent20')}
              </p>
              <p>
                <strong>{t('recPiercingContent6')}</strong> {t('recPiercingContent21')}
              </p>
              <p>
                <strong>{t('recPiercingContent8')}</strong> {t('recPiercingContent22')}
              </p>
              <p>
                <strong>{t('recPiercingContent23')}</strong> {t('recPiercingContent24')}
              </p>
              
              <h5>{t('recPiercingContent25')}</h5>
              <p>
                <strong>{t('recPiercingContent4')}</strong> {t('recPiercingContent26')}
              </p>
              <p>
                <strong>{t('recPiercingContent6')}</strong> {t('recPiercingContent27')}
              </p>
              <p>
                <strong>{t('recPiercingContent8')}</strong> {t('recPiercingContent28')}
              </p>
              <p>
                <strong>{t('recPiercingContent16')}</strong> {t('recPiercingContent29')}
              </p>
              
              <h4>{t('recPiercingContent30')}</h4>
              
              <h5>{t('recPiercingContent31')}</h5>
              <p>
                <strong>{t('recPiercingContent4')}</strong> {t('recPiercingContent32')}
              </p>
              <p>
                <strong>{t('recPiercingContent6')}</strong> {t('recPiercingContent33')}
              </p>
              <p>
                <strong>{t('recPiercingContent8')}</strong> {t('recPiercingContent28')}
              </p>
              <p>
                <strong>{t('recPiercingContent34')}</strong> {t('recPiercingContent35')}
              </p>
              
              <h5>{t('recPiercingContent36')}</h5>
              <p>
                <strong>{t('recPiercingContent4')}</strong> {t('recPiercingContent37')}
              </p>
              <p>
                <strong>{t('recPiercingContent6')}</strong> {t('recPiercingContent33')}
              </p>
              <p>
                <strong>{t('recPiercingContent8')}</strong> {t('recPiercingContent15')}
              </p>
              <p>
                <strong>{t('recPiercingContent38')}</strong> {t('recPiercingContent39')}
              </p>
              
              <h4>{t('recPiercingContent40')}</h4>
              
              <h5>{t('recPiercingContent41')}</h5>
              <ul>
                <li><strong>{t('recPiercingContent42')}</strong> {t('recPiercingContent43')}</li>
                <li><strong>{t('recPiercingContent44')}</strong> {t('recPiercingContent45')}</li>
                <li><strong>{t('recPiercingContent46')}</strong> {t('recPiercingContent47')}</li>
                <li><strong>{t('recPiercingContent48')}</strong> {t('recPiercingContent49')}</li>
              </ul>
              
              <h5>{t('recPiercingContent50')}</h5>
              <ul>
                <li><strong>{t('recPiercingContent51')}</strong> {t('recPiercingContent52')}</li>
                <li><strong>{t('recPiercingContent53')}</strong> {t('recPiercingContent54')}</li>
                <li><strong>{t('recPiercingContent55')}</strong> {t('recPiercingContent56')}</li>
                <li><strong>{t('recPiercingContent57')}</strong> {t('recPiercingContent58')}</li>
              </ul>
            </div>
            </div>
          </div>
        </section>

        <section id="aftercare" className="rec-section">
          <div className="rec-section-header">
            <div className="rec-section-info">
              <h3>{t('professionalAftercare')}</h3>
              <div className="rec-section-details">
                <span className="rec-section-time">8 {t('minRead')}</span>
                <span className="rec-section-difficulty rec-section-difficulty--beginner">{t('beginner')}</span>
              </div>
            </div>
          </div>
          <div className="rec-section-intro">
            <p>{t('recAftercareIntro')}</p>
          </div>
          <div className="rec-quick-tips">
            <h4>{t('quickTips')}</h4>
            <ul className="rec-tips-list">
              <li className="rec-tip-item"><span className="rec-tip-text">{t('recAftercareQuickTip1')}</span><span className="rec-tip-icon">💡</span></li>
              <li className="rec-tip-item"><span className="rec-tip-text">{t('recAftercareQuickTip2')}</span><span className="rec-tip-icon">💡</span></li>
              <li className="rec-tip-item"><span className="rec-tip-text">{t('recAftercareQuickTip3')}</span><span className="rec-tip-icon">💡</span></li>
            </ul>
          </div>
          <div className="rec-section-body">
          <div className="rec-section-content">
            <div>
              <p>{t('recAftercareContent1')}</p>
              
              <h4>{t('recAftercareContent2')}</h4>
              
              <h5>{t('recAftercareContent3')}</h5>
              <ul>
                <li><strong>{t('recAftercareContent4')}</strong> {t('recAftercareContent5')}</li>
                <li><strong>{t('recAftercareContent6')}</strong> {t('recAftercareContent7')}</li>
                <li><strong>{t('recAftercareContent8')}</strong> {t('recAftercareContent9')}</li>
                <li><strong>{t('recAftercareContent10')}</strong> {t('recAftercareContent11')}</li>
              </ul>
              
              <h5>{t('recAftercareContent12')}</h5>
              <ul>
                <li><strong>{t('recAftercareContent13')}</strong> {t('recAftercareContent14')}</li>
                <li><strong>{t('recAftercareContent15')}</strong> {t('recAftercareContent16')}</li>
                <li><strong>{t('recAftercareContent17')}</strong> {t('recAftercareContent18')}</li>
                <li><strong>{t('recAftercareContent19')}</strong> {t('recAftercareContent20')}</li>
              </ul>
              
              <h5>{t('recAftercareContent21')}</h5>
              <ul>
                <li><strong>{t('recAftercareContent22')}</strong> {t('recAftercareContent23')}</li>
                <li><strong>{t('recAftercareContent24')}</strong> {t('recAftercareContent25')}</li>
                <li><strong>{t('recAftercareContent26')}</strong> {t('recAftercareContent27')}</li>
                <li><strong>{t('recAftercareContent28')}</strong> {t('recAftercareContent29')}</li>
              </ul>
              
              <h4>{t('recAftercareContent30')}</h4>
              
              <h5>{t('recAftercareContent31')}</h5>
              <ul>
                <li><strong>{t('recAftercareContent32')}</strong> {t('recAftercareContent33')}</li>
                <li><strong>{t('recAftercareContent34')}</strong> {t('recAftercareContent35')}</li>
                <li><strong>{t('recAftercareContent36')}</strong> {t('recAftercareContent37')}</li>
                <li><strong>{t('recAftercareContent38')}</strong> {t('recAftercareContent39')}</li>
              </ul>
              
              <h5>{t('recAftercareContent40')}</h5>
              <ul>
                <li><strong>{t('recAftercareContent41')}</strong> {t('recAftercareContent42')}</li>
                <li><strong>{t('recAftercareContent43')}</strong> {t('recAftercareContent44')}</li>
                <li><strong>{t('recAftercareContent45')}</strong> {t('recAftercareContent46')}</li>
                <li><strong>{t('recAftercareContent47')}</strong> {t('recAftercareContent48')}</li>
              </ul>
              
              <h4>{t('recAftercareContent49')}</h4>
              
              <h5>{t('recAftercareContent50')}</h5>
              <ul>
                <li><strong>{t('recAftercareContent51')}</strong> {t('recAftercareContent52')}</li>
                <li><strong>{t('recAftercareContent53')}</strong> {t('recAftercareContent54')}</li>
                <li><strong>{t('recAftercareContent55')}</strong> {t('recAftercareContent56')}</li>
                <li><strong>{t('recAftercareContent57')}</strong> {t('recAftercareContent58')}</li>
                <li><strong>{t('recAftercareContent59')}</strong> {t('recAftercareContent60')}</li>
              </ul>
              
              <h5>{t('recAftercareContent61')}</h5>
              <ul>
                <li><strong>{t('recAftercareContent62')}</strong> {t('recAftercareContent63')}</li>
                <li><strong>{t('recAftercareContent64')}</strong> {t('recAftercareContent65')}</li>
                <li><strong>{t('recAftercareContent66')}</strong> {t('recAftercareContent67')}</li>
                <li><strong>{t('recAftercareContent68')}</strong> {t('recAftercareContent69')}</li>
                <li><strong>{t('recAftercareContent70')}</strong> {t('recAftercareContent71')}</li>
              </ul>
              
              <h4>{t('recAftercareContent72')}</h4>
              <p>{t('recAftercareContent73')}</p>
            </div>
            </div>
          </div>
        </section>

        <section id="safety-tips" className="rec-section">
          <div className="rec-section-header">
            <div className="rec-section-info">
              <h3>{t('safetyStandardsHygiene')}</h3>
              <div className="rec-section-details">
                <span className="rec-section-time">6 {t('minRead')}</span>
                <span className="rec-section-difficulty rec-section-difficulty--beginner">{t('beginner')}</span>
              </div>
            </div>
          </div>
          <div className="rec-section-intro">
            <p>{t('recSafetyIntro')}</p>
          </div>
          <div className="rec-quick-tips">
            <h4>{t('quickTips')}</h4>
            <ul className="rec-tips-list">
              <li className="rec-tip-item"><span className="rec-tip-text">{t('recSafetyQuickTip1')}</span><span className="rec-tip-icon">💡</span></li>
              <li className="rec-tip-item"><span className="rec-tip-text">{t('recSafetyQuickTip2')}</span><span className="rec-tip-icon">💡</span></li>
              <li className="rec-tip-item"><span className="rec-tip-text">{t('recSafetyQuickTip3')}</span><span className="rec-tip-icon">💡</span></li>
            </ul>
          </div>
          <div className="rec-section-body">
          <div className="rec-section-content">
            <div>
              <p>{t('recSafetyContent1')}</p>
              
              <h4>{t('recSafetyContent2')}</h4>
              
              <h5>{t('recSafetyContent3')}</h5>
              <ul>
                <li><strong>{t('recSafetyContent4')}</strong> {t('recSafetyContent5')}</li>
                <li><strong>{t('recSafetyContent6')}</strong> {t('recSafetyContent7')}</li>
                <li><strong>{t('recSafetyContent8')}</strong> {t('recSafetyContent9')}</li>
                <li><strong>{t('recSafetyContent10')}</strong> {t('recSafetyContent11')}</li>
              </ul>
              
              <h5>{t('recSafetyContent12')}</h5>
              <ul>
                <li><strong>{t('recSafetyContent13')}</strong> {t('recSafetyContent14')}</li>
                <li><strong>{t('recSafetyContent15')}</strong> {t('recSafetyContent16')}</li>
                <li><strong>{t('recSafetyContent17')}</strong> {t('recSafetyContent18')}</li>
                <li><strong>{t('recSafetyContent19')}</strong> {t('recSafetyContent20')}</li>
              </ul>
              
              <h4>{t('recSafetyContent21')}</h4>
              
              <h5>{t('recSafetyContent22')}</h5>
              <ul>
                <li><strong>{t('recSafetyContent23')}</strong> {t('recSafetyContent24')}</li>
                <li><strong>{t('recSafetyContent25')}</strong> {t('recSafetyContent26')}</li>
                <li><strong>{t('recSafetyContent27')}</strong> {t('recSafetyContent28')}</li>
                <li><strong>{t('recSafetyContent29')}</strong> {t('recSafetyContent30')}</li>
              </ul>
              
              <h5>{t('recSafetyContent31')}</h5>
              <ul>
                <li><strong>{t('recSafetyContent32')}</strong> {t('recSafetyContent33')}</li>
                <li><strong>{t('recSafetyContent34')}</strong> {t('recSafetyContent35')}</li>
                <li><strong>{t('recSafetyContent36')}</strong> {t('recSafetyContent37')}</li>
                <li><strong>{t('recSafetyContent38')}</strong> {t('recSafetyContent39')}</li>
              </ul>
              
              <h4>{t('recSafetyContent40')}</h4>
              
              <h5>{t('recSafetyContent41')}</h5>
              <ul>
                <li><strong>{t('recSafetyContent42')}</strong> {t('recSafetyContent43')}</li>
                <li><strong>{t('recSafetyContent44')}</strong> {t('recSafetyContent45')}</li>
                <li><strong>{t('recSafetyContent46')}</strong> {t('recSafetyContent47')}</li>
                <li><strong>{t('recSafetyContent48')}</strong> {t('recSafetyContent49')}</li>
              </ul>
              
              <h5>{t('recSafetyContent50')}</h5>
              <ul>
                <li><strong>{t('recSafetyContent51')}</strong> {t('recSafetyContent52')}</li>
                <li><strong>{t('recSafetyContent53')}</strong> {t('recSafetyContent54')}</li>
                <li><strong>{t('recSafetyContent55')}</strong> {t('recSafetyContent56')}</li>
                <li><strong>{t('recSafetyContent57')}</strong> {t('recSafetyContent58')}</li>
              </ul>
              
              <h4>{t('recSafetyContent59')}</h4>
              
              <h5>{t('recSafetyContent60')}</h5>
              <ul>
                <li><strong>{t('recSafetyContent61')}</strong> {t('recSafetyContent62')}</li>
                <li><strong>{t('recSafetyContent63')}</strong> {t('recSafetyContent64')}</li>
                <li><strong>{t('recSafetyContent65')}</strong> {t('recSafetyContent66')}</li>
                <li><strong>{t('recSafetyContent67')}</strong> {t('recSafetyContent68')}</li>
              </ul>
              
              <h5>{t('recSafetyContent69')}</h5>
              <ul>
                <li><strong>{t('recSafetyContent70')}</strong> {t('recSafetyContent71')}</li>
                <li><strong>{t('recSafetyContent72')}</strong> {t('recSafetyContent73')}</li>
                <li><strong>{t('recSafetyContent74')}</strong> {t('recSafetyContent75')}</li>
                <li><strong>{t('recSafetyContent76')}</strong> {t('recSafetyContent77')}</li>
              </ul>
            </div>
            </div>
          </div>
        </section>

        <footer className="rec-footer">
          <h3>{t('readyExpressIndividuality')}</h3>
          <p>
            {t('dontWaitExploreBodyArt')}
          </p>
          <div className="rec-cta-row">
            <Link className="btn primary" to="/service/tattoo-&-piercing-shops">{t('bookTattooConsultation')}</Link>
            <Link className="btn outline" to="/service/tattoo-&-piercing-shops">{t('bookPiercingAppointment')}</Link>
          </div>
        </footer>
      </article>
    </div>
  );
}